import { useContext } from 'react'

import { GlobalContext } from '../../context'

const WidgetPlaceholderRecentDocs = () => {
  const { t } = useContext(GlobalContext)

  return (
    <div className="customize-panel-widget-placeholder">
      <div className="customize-panel-widget-placeholder__head">
        <p>{t('dashboard.recent_documents')}</p>
      </div>
      <div className="customize-panel-widget-placeholder__body">
        <ul className="list">
          <li><span className="material-symbols-outlined">description</span> <div className="line line--1"></div></li>
          <li><span className="material-symbols-outlined">description</span> <div className="line line--2"></div></li>
          <li><span className="material-symbols-outlined">description</span> <div className="line line--3"></div></li>
        </ul>
      </div>
    </div>
  )
}

export default WidgetPlaceholderRecentDocs